var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplashSpa = function SvgSplashSpa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    strokeLinecap: "round",
    d: "M25.304 11.54A9.7 9.7 0 0 1 27.75 18c0 5.385-4.365 9.75-9.75 9.75S8.25 23.385 8.25 18 12.615 8.25 18 8.25c1.846 0 3.572.513 5.043 1.404"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    d: "M19.083 12.944c0 .564-.33 1.567-.732 2.324a.393.393 0 0 1-.706.002c-.4-.739-.729-1.705-.729-2.326 0-.797.485-1.444 1.084-1.444.598 0 1.083.647 1.083 1.444ZM16.917 23.056c0-.564.33-1.567.732-2.324a.393.393 0 0 1 .706-.002c.4.739.729 1.705.729 2.326 0 .797-.485 1.444-1.084 1.444-.598 0-1.083-.647-1.083-1.444ZM23.056 19.083c-.564 0-1.567-.33-2.324-.732a.393.393 0 0 1-.002-.706c.739-.4 1.705-.729 2.326-.729.797 0 1.444.485 1.444 1.084 0 .598-.647 1.083-1.444 1.083ZM20.808 22.34c-.398-.398-.874-1.34-1.125-2.16a.393.393 0 0 1 .498-.5c.806.239 1.72.69 2.16 1.129.563.564.678 1.364.255 1.787s-1.224.309-1.788-.255ZM13.66 20.808c.398-.398 1.34-.874 2.16-1.125a.393.393 0 0 1 .5.498c-.239.806-.69 1.72-1.129 2.16-.564.563-1.364.678-1.787.255s-.309-1.224.255-1.788ZM22.34 15.192c-.398.398-1.34.874-2.16 1.125a.393.393 0 0 1-.5-.498c.239-.806.69-1.72 1.129-2.16.564-.564 1.364-.678 1.787-.255s.309 1.223-.255 1.788Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9B9A",
    d: "M24.75 10.607a.418.418 0 1 1-.835 0 .418.418 0 0 1 .835 0"
  }))));
};
export default SvgSplashSpa;